import { Optional } from '@mews/std';
import { isNil } from '@optimus-web/common';

export function disableScroll(element: HTMLElement) {
    if (!element) {
        return;
    }

    const { overflowX, overflowY } = element.style;

    element.style.overflowX = 'hidden';
    element.style.overflowY = 'hidden';

    return () => {
        element.style.overflowX = overflowX;
        element.style.overflowY = overflowY;
    };
}

export function isDescendant(element: Element | null, parent: Element) {
    let node = element as Optional<Node>;
    while (!isNil(node)) {
        if (node === parent) {
            return true;
        }
        node = node.parentNode;
    }

    return false;
}
